<template>
    <form
        @submit.prevent="updateUser"
        :action="url"
        method="post"
        class="card space-y-4"
    >
        <h2 class="heading-2">Update User Info</h2>

        <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
            <text-input
                label="First Name"
                name="first_name"
                type="text"
                v-model="form.first_name"
                :error="form.errors.first_name"
            />
            <text-input
                label="Last Name"
                name="last_name"
                type="text"
                v-model="form.last_name"
                :error="form.errors.last_name"
            />
        </div>

        <text-input
            label="Email"
            name="email"
            type="email"
            v-model="form.email"
            :error="form.errors.email"
        />

        <div class="flex justify-end items-center space-x-4">
            <transition
                enter-from-class="opacity-0"
                enter-active-class="transition-opacity ease-in duration-200"
                enter-to-class="opacity-100"
                leave-from-class="opacity-100"
                leave-active-class="transition-opacity ease-out duration-200"
                leave-to-class="opacity-0"
            >
                <div
                    v-if="form.recentlySuccessful"
                    class="text-gray-500"
                >
                    Saved.
                </div>
            </transition>

            <loading-button
                :loading="form.processing"
                type="submit"
                class="btn btn-green"
            >
                Update
            </loading-button>
        </div>
    </form>
</template>

<script setup>
import useForm from '@/functions/useForm'
import { useUserStore } from '@/stores/user'
import { useNotificationStore } from '@/stores/notification'

const user = useUserStore()
const notification = useNotificationStore()

const props = defineProps({
    url: {
        type: String,
        required: true,
    }
})

const form = useForm({
    first_name: user.first_name,
    last_name: user.last_name,
    email: user.email,
})

const updateUser = () => {
    notification.clear()

    form.put(props.url, {
        onSuccess: (newUser) => {
            user.set(newUser)
            if(! form.dirty('email')) return

            notification.set({
                'type': 'modal',
                'body': 'A new verification link has been sent to the email address you provided during registration.',
                'heading': 'Check Your Email',
            })
        }
    })
}
</script>
